// tableFormatters.js
import { Avatar } from 'primereact/avatar';
import { Tag } from 'primereact/tag';



const getAvatarStyle = (name) => {
  const firstLetter = name ? name.charAt(0).toUpperCase() : '?';
  
  const colors = {
    'A': { bg: '#FFEbee', text: '#C62828' }, 
    'B': { bg: '#FCE4EC', text: '#AD1457' }, 
    'C': { bg: '#F3E5F5', text: '#6A1B9A' }, 
    'D': { bg: '#EDE7F6', text: '#4527A0' }, 
    'E': { bg: '#E8EAF6', text: '#283593' }, 
    'F': { bg: '#E3F2FD', text: '#1565C0' }, 
    'G': { bg: '#E1F5FE', text: '#0277BD' }, 
    'H': { bg: '#E0F7FA', text: '#00838F' }, 
    'I': { bg: '#E0F2F1', text: '#00695C' }, 
    'J': { bg: '#E8F5E9', text: '#2E7D32' }, 
    'K': { bg: '#F1F8E9', text: '#33691E' }, 
    'L': { bg: '#F9FBE7', text: '#827717' }, 
    'M': { bg: '#FFFDE7', text: '#F57F17' }, 
    'N': { bg: '#FFF8E1', text: '#FF8F00' }, 
    'O': { bg: '#FFF3E0', text: '#EF6C00' }, 
    'P': { bg: '#FBE9E7', text: '#D84315' }, 
    'R': { bg: '#ECEFF1', text: '#37474F' }, 
    'S': { bg: '#E0F2F1', text: '#004d40' }, 
    'T': { bg: '#E8F5E9', text: '#1b5e20' }, 
  };

  return colors[firstLetter] || { bg: '#FEF3C7', text: '#92400E' };
};




export const formatDateWithDaysAgo = (dateString) => {
  if (!dateString) return "-";
  const date = new Date(dateString);
  
  const months = ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'];
  const day = date.getDate();
  const month = months[date.getMonth()];
  const year = date.getFullYear();
  
  const now = new Date();
  const diffTime = now - date;
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
  
  let daysText = '';
  if (diffDays === 0) {
    daysText = "aujourd'hui";
  } else if (diffDays === 1) {
    daysText = "il y a 1 jour";
  } else {
    daysText = `il y a ${diffDays} jours`;
  }
  
  return (
    <div>
      <div style={{ fontSize: '13px',fontWeight: '600' }}>{day} {month} {year}</div>
      <small style={{ color: '#6c757d', fontSize: '11px' }}>
        {daysText}
      </small>
    </div>
  );
};

export const formatDateWithDaysAgoAndNbCall = (dateString,rowData) => {
  if (!dateString) return "-";
  const date = new Date(dateString);

  const nb = rowData.urgence;
  
  const months = ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'];
  const day = date.getDate();
  const month = months[date.getMonth()];
  const year = date.getFullYear();
  
  const now = new Date();
  const diffTime = now - date;
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
  
  let daysText = '';
  if (diffDays === 0) {
    daysText = "aujourd'hui";
  } else if (diffDays === 1) {
    daysText = "il y a 1 jour";
  } else {
    daysText = `il y a ${diffDays} jours`;
  }
  
  return (
    <div>
      <div style={{ fontSize: '13px',fontWeight: '600' }}>{day} {month} {year} </div> 
      <small style={{ color: '#6c757d', fontSize: '11px' }}>
        {daysText} <small style={{ color: '#6c757d', fontSize: '11px' }}>({nb})</small>
      </small>
    </div>
  );
};

export const formatDateWithDaysAgoAndHour = (dateString,rowData) => {
  if (!dateString) return "-";
  const date = new Date(dateString);

  const nb = rowData.nbappels;
  const hour = rowData.heureDem?.split(":").slice(0, 2).join(":")
  
  const months = ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'];
  const day = date.getDate();
  const month = months[date.getMonth()];
  const year = date.getFullYear();
  
  const now = new Date();
  const diffTime = date - now;
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  
  let daysText = '';
  if (diffDays === 0) {
    daysText = "aujourd'hui";
  } else if (diffDays === 1) {
    daysText = "Dans 1 jour";
  } else if (diffDays > 1) {
    daysText = `Dans ${diffDays} jours`;
  }
  
  return (
    <div>
      <div style={{ fontSize: '13px',fontWeight: '600' }}>{day} {month} {year} à {hour}</div> 
      <small style={{ color: '#6c757d', fontSize: '11px' }}>
        {daysText} <small style={{ color: '#6c757d', fontSize: '11px' }}>({nb})</small>
      </small>
    </div>
  );
};


export const formatDateWithDaysLeft = (dateString) => {
  if (!dateString) return "-";
  const date = new Date(dateString);
  
  const months = ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'];
  const day = date.getDate();
  const month = months[date.getMonth()];
  const year = date.getFullYear();
  
  const now = new Date();
  const diffTime = date - now;
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  
  let daysText = '';
  if (diffDays === 0) {
    daysText = "aujourd'hui";
  } else if (diffDays === 1) {
    daysText = "Dans 1 jour";
  } else if (diffDays > 1) {
    daysText = `Dans ${diffDays} jours`;
  }
  
  return (
    <div>
      <div style={{ fontSize: '13px', fontWeight: '600' }}>{day} {month} {year}</div>
      <small style={{ color: '#6c757d', fontSize: '11px' }}>
        {daysText}
      </small>
    </div>
  );
};



// 2. Formatage simple de la date (JJ/MM/AAAA)
export const formatDateSimple = (dateString) => {
  if (!dateString) return "-";
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

// 3. Obtenir les initiales d'un nom
export const getInitials = (name) => {
  if (!name) return "?";
  return name
    .split(' ')
    .map(word => word[0])
    .join('')
    .toUpperCase()
    .substring(0, 2);
};

// 4. Template Client avec Avatar
export const clientTemplate = (rowData, copyToClipboard) => {
  const typeClient = rowData.type_client || (rowData.entreprise ? `Entreprise · ${rowData.entreprise}` : "Particulier");
  
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
      <Avatar 
        label={getInitials(rowData.nomPrenom)} 
        size="normal" 
        shape="circle"
        style={{ backgroundColor: '#6366f1', color: 'white' }}
      />
      <div>
        <div 
          style={{ cursor: 'pointer', fontWeight: '500' }}
          onClick={() => copyToClipboard(rowData.nomPrenom)}
        >
          {rowData.nomPrenom}
        </div>
        <small style={{ color: '#6c757d', fontSize: '12px' }}>
          {typeClient}
        </small>
      </div>
    </div>
  );
};

// 5. Template Contact (email + téléphone)
export const contactTemplate = (rowData, copyToClipboard) => {
  return (
    <div>
      <div 
        style={{ 
            fontWeight: '600', 
            color: '#333', 
            cursor: 'pointer',
            fontSize: '13px' 
          }}
        onClick={() => copyToClipboard(rowData.mail)}
      >
        {rowData.mail}
      </div>
      <div 
        style={{ cursor: 'pointer', fontSize: '13px', marginTop: '4px' }}
        onClick={() => copyToClipboard(rowData.num)}
      >
        {rowData.num}
      </div>
    </div>
  );
};

// 6. Template Invités avec icône
export const invitesTemplate = (rowData, copyToClipboard) => {
  if (!rowData.nbpers || rowData.nbpers === "") {
    return <span style={{ color: '#6c757d' }}>-</span>;
  }
  
  return (
    <div 
      style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px' ,fontSize: '13px'}}
      onClick={() => copyToClipboard(rowData.nbpers)}
    >
      <span style={{fontSize: '13px'}}>{rowData.nbpers}</span>
    </div>
  );
};

// 7. Template Type avec Tag
export const typeTemplate = (rowData) => {
  const typeValue = rowData.type_bar;
  
  let displayText = typeValue || '-';
  if (typeValue === 'avec_alcool') displayText = 'Avec alcool';
  if (typeValue === 'sans_alcool') displayText = 'Sans alcool';
  if (typeValue === 'avec_alcool, sans_alcool') displayText = 'Avec et sans alcool';

  let bgColor = '#fdf2f0'; 
  let textColor = '#a33b1f'; 
  let dotColor = '#a33b1f'; 

  if (displayText === 'Sans alcool') {
    bgColor = '#f0fdf4';
    textColor = '#166534';
    dotColor = '#166534';
  }

  return (
    <div>
      <div 
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '8px',
          padding: '4px 14px',
          borderRadius: '20px',
          backgroundColor: bgColor,
          color: textColor,
          fontSize: '13px',
          fontWeight: '500',
          whiteSpace: 'nowrap'
        }}
      >
        <span style={{ 
          height: '6px', 
          width: '6px', 
          borderRadius: '50%', 
          backgroundColor: dotColor 
        }}></span>
        
        {displayText}
      </div>
    </div>
  );
};

// 8. Template Status avec Tag (générique pour différents statuts)
export const statusTemplate = (status, statusMap) => {
  const config = statusMap[status] || { severity: 'secondary', label: status || '-' };
  
  return (
    <Tag 
      value={config.label} 
      severity={config.severity}
    />
  );
};

// 9. Template Nom simple avec copie
export const nameTemplate = (rowData, copyToClipboard, fieldName = 'nom') => {
  const fullName = rowData[fieldName] || "";
  const subTitle = rowData.duree || "Inconnu"; 
  
  const initials = fullName
    .split(' ')
    .map(n => n[0])
    .join('')
    .toUpperCase()
    .substring(0, 2);

  const avatarStyle = getAvatarStyle(fullName);

  return (
    <div className="flex align-items-center gap-3">
      <div style={{
        width: '40px',
        height: '40px',
        borderRadius: '50%',
        backgroundColor: avatarStyle.bg,
        color: avatarStyle.text,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontWeight: '600',
        fontSize: '13px',
        flexShrink: 0
      }}>
        {initials}
      </div>

      {/* Textes : Nom et Sous-titre */}
      <div className="flex flex-column" style={{ lineHeight: '1.2' }}>
        <span 
          style={{ 
            fontWeight: '600', 
            color: '#333', 
            cursor: 'pointer',
            fontSize: '13px' 
          }}
          onClick={() => copyToClipboard(fullName)}
        >
          {fullName}
        </span>
        <span style={{ 
          fontSize: '12px', 
          color: '#9ca3af'
        }}>
          {subTitle}
        </span>
      </div>
    </div>
  );
};



// 10. Template Téléphone avec icône
export const phoneTemplate = (rowData, copyToClipboard, fieldName = 'tel') => {
  if (!rowData[fieldName]) return "-";
  
  return (
    <div 
      style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px' }}
      onClick={() => copyToClipboard(rowData[fieldName])}
    >
      <i className="pi pi-phone" style={{ color: '#6366f1' }} />
      <span>{rowData[fieldName]}</span>
    </div>
  );
};

// 11. Template Email avec icône
export const emailTemplate = (rowData, copyToClipboard, fieldName = 'email') => {
  if (!rowData[fieldName]) return "-";
  
  return (
    <div 
      style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px', color: '#6366f1' }}
      onClick={() => copyToClipboard(rowData[fieldName])}
    >
      <i className="pi pi-envelope" style={{ fontSize: '13px' }} />
      <span>{rowData[fieldName]}</span>
    </div>
  );
};

// 12. Template Montant avec formatage euro
export const amountTemplate = (amount) => {
  if (!amount && amount !== 0) return "-";
  
  return new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR'
  }).format(amount);
};

// 13. Template Date complète avec heure
export const dateTimeTemplate = (dateString) => {
  if (!dateString) return "-";
  const date = new Date(dateString);
  
  return (
    <div>
      <div>{date.toLocaleDateString('fr-FR')}</div>
      <small style={{ color: '#6c757d', fontSize: '11px' }}>
        {date.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}
      </small>
    </div>
  );
};